var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelSelectedItemIcon = function SvgCancelSelectedItemIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13.4142L18.2929 19.7071L19.7071 18.2928L13.4143 12L19.7071 5.70715L18.2929 4.29294L12.0001 10.5858L5.70712 4.29285L4.29291 5.70706L10.5858 12L4.29291 18.2929L5.70712 19.7072L12.0001 13.4142Z",
    fill: "#767676"
  })));
};
export { SvgCancelSelectedItemIcon as ReactComponent };
export default __webpack_public_path__ + "assets/030fa085.svg";